// extracted by mini-css-extract-plugin
export default {"sale":"_3LHm6"};